export default __webpack_public_path__ + "static/media/performance.1622725b.svg";